module.exports = __webpack_public_path__ + "img/HQ-PA2W1CH.e4b201ec.jpg";